
import {ComponentEnum} from "@/config/config-types";
import TaxonPicker from "@/components/picker/TaxonPicker.vue";
import NumberPicker from "@/components/picker/NumberPicker.vue";
import BooleanPicker from "@/components/picker/BooleanPicker.vue";
import ImagePicker from "@/components/picker/ImagePicker.vue";
import SpecimenPicker from "@/components/picker/SpecimenPicker.vue";
import CategoryPicker from "@/components/picker/CategoryPicker.vue";
import StringPicker from "@/components/picker/StringPicker.vue";
import PersonPicker from "@/components/picker/PersonPicker.vue";
import ConfirmPopup from 'primevue/confirmpopup';
import {defineComponent} from "vue";
import Button from "primevue/button";
import Card from "primevue/card";
import Message from "primevue/message";
import Panel from "primevue/panel";
import InfoButton from "@/components/legend/InfoButton.vue";
import {lookupURL, taxonByIdURL} from "@/config/app-settings";
import axios from "axios";
import DatePicker from "@/components/picker/DatePicker.vue";
import MultiSelectPicker from "@/components/picker/MultiSelectPicker.vue";

export default defineComponent({
  name: "FungusRecordForm",
  components: {
    StringPicker,
    CategoryPicker, MultiSelectPicker,
    SpecimenPicker,
    ImagePicker, BooleanPicker, NumberPicker, TaxonPicker, PersonPicker, DatePicker, InfoButton,
    Button, Card, Message, Panel, ConfirmPopup
  },
  data() {
    return {
      ComponentEnum,
      isCollapsed: false,
      removeRequested: false,
      taxonNameDict: {},
      substrateCoarseWithChildCategories: [1,3,5,6,7,8,9,10,11] // not all substrate coarse categories have dependent child categories (substrate fine)
    }
  },
  computed: {
    rec(): any {
      return this.$store.state.fungusRecordForm.records
    },
    storedSubstrateCoarse(): Number {
      return this.$store.state.substrateCoarse
    }
  },
  watch: {
    rec() {
      this.getDisplayName()
    }
  },
  props: {
    recordIdx: Number,
    record: Object,
  },
  methods: {
    select(val: any) {
      this.$store.commit('setFungusRecordValue', {idx: this.recordIdx, key: val.key, value: val.value})
      if (val.key == 'taxonReferenceSuggested.taxonId') {
        this.getDisplayName()
      }
    },
    remove(event: any) {
      this.$confirm.require({
        target: event.currentTarget,
        message: this.$t('form.confirmDeleteRecord'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.$store.commit('removeFungusRecord', this.recordIdx)
        }
      });
    },
    getDisplayName() {
      this.$store.state.fungusRecordForm.records.forEach((rec: any, idx: any) => {
        let taxonId = rec.find((f: any) => f.name === 'taxonReferenceSuggested').value.find((fg: any) => fg.name === 'taxonId').value
        if (taxonId) {
          axios.get(taxonByIdURL + '?taxonId=' + taxonId)
              .then((res) => {
                    // @ts-ignore
                    this.taxonNameDict[idx] = res.data[0].LABEL
                    // store reference work ID of selected taxon
                    rec.find((f: any) => f.name === 'taxonReferenceSuggested').value.find((fg: any) => fg.name === 'ifFlorAppReferenceWork').value = res.data[0].ifFlorAppReferenceWork
                  }
              )
              .catch(e => console.log(e))
        }
      })


    }
  },
  mounted() {
    this.getDisplayName()
  }
})
